/* eslint-disable consistent-return,max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/es';
import SweetAlert from 'react-bootstrap-sweetalert';
// @material-ui/icons
import Check from '@material-ui/icons/Check';
import ArrowUp from '@material-ui/icons/ArrowUpward';
import SupervisedUser from '@material-ui/icons/SupervisedUserCircle';
import User from '@material-ui/icons/AccountCircle';
import Clear from '@material-ui/icons/Close';
// @material-ui/core components
import FilterStyles from 'assets/jss/AdsFilter';
import Checkbox from '@material-ui/core/Checkbox/Checkbox';
import withStyles from '@material-ui/core/styles/withStyles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import Button from 'components/UI/CustomButtons/Button';
import GridContainer from 'components/UI/Grid/GridContainer';
import CustomInput from 'components/UI/CustomInput/CustomInput';
// our components
import { creditBundlesStatus, userRanks } from 'config';
import Datepicker from 'components/common/DatePicker';
import SectionDivider from 'components/common/SectionDivider/SectionDivider';
import UserSelect from 'components/User/Select';
import AuthContext from 'helpers/authContext';

/**
 * Variable to define default selected status
 */
const defaultSelectedStatus = [
  creditBundlesStatus.CREATED,
  creditBundlesStatus.STARTED,
  creditBundlesStatus.COMPLETED,
  creditBundlesStatus.EXPIRED,
  creditBundlesStatus.CANCELLED,
];

class CreditBundleFilter extends React.Component {
  constructor(props) {
    super(props);
    const { appliedFilter } = props;
    this.state = {
      selectedCreditBundlesStatus:
        (appliedFilter && appliedFilter.status) || defaultSelectedStatus,
      localFilter: appliedFilter || null,
      showSelectAgency: false,
      showSelectOwner: false,
    };
  }

  /**
   * @description
   * Change filters.
   *
   * @param {Object} changedFilter - Changed filters values.
   * @param {*} callback - Callback waiting for setState.
   */
  handleChangeFilter = (changedFilter, callback = null) => {
    const { localFilter } = this.state;
    this.setState(
      { localFilter: { ...localFilter, ...changedFilter } },
      callback,
    );
  };

  /**
   * @description
   * Update selected status.
   *
   * @param {*} callback - Callback waiting for setState.
   */
  updateSelectedCheckboxes = callback => {
    const { selectedCreditBundlesStatus } = this.state;
    this.handleChangeFilter(
      selectedCreditBundlesStatus.length === 0
        ? { status: undefined }
        : { status: selectedCreditBundlesStatus },
      callback,
    );
  };

  /**
   * @description
   * Handle select status checkboxes.
   *
   * @param {string} checkLabel - Status selected.
   * @param {*} callback - Callback waiting for setState.
   * @returns {undefined} No return.
   */
  handleStatusCheck = (checkLabel, callback = null) => {
    const { selectedCreditBundlesStatus } = this.state;
    if (selectedCreditBundlesStatus.indexOf(checkLabel) !== -1) {
      const newSelected = selectedCreditBundlesStatus.filter(
        status => status !== checkLabel,
      );
      this.setState({ selectedCreditBundlesStatus: newSelected }, () =>
        this.updateSelectedCheckboxes(callback),
      );
    } else {
      this.setState(
        {
          selectedCreditBundlesStatus: [
            ...selectedCreditBundlesStatus,
            checkLabel,
          ],
        },
        () => this.updateSelectedCheckboxes(callback),
      );
    }
  };

  handleSelectedAgency = agency => {
    const { localFilter, showSelectAgency } = this.state;

    let oldOwner = localFilter.userAgency;
    if (localFilter.agency && agency.id !== localFilter.agency) {
      oldOwner = undefined;
    }

    // change state
    this.setState({
      showSelectAgency: !showSelectAgency,
      localFilter: {
        ...localFilter,
        agency: agency.id,
        agencyName: agency.fullname,
        userAgency: oldOwner,
      },
    });
  };

  /**
   * @description
   * Call filter callback.
   */
  handleFilter = () => {
    const { filter } = this.props;
    const { localFilter } = this.state;
    filter({ ...localFilter });
  };

  /**
   * @description
   * Render full filter's box.
   * @returns {*} - AdFilter's box.
   */
  render() {
    const { classes, restartFilters, t, showFilters } = this.props;
    const {
      selectedCreditBundlesStatus,
      localFilter,
      showSelectOwner,
      showSelectAgency,
    } = this.state;
    return (
      <AuthContext.Consumer>
        {/* eslint-disable-next-line consistent-return */}
        {user => {
          const hasGeneral =
            user.allPermissions.filter(
              permission => permission.codename === 'list_creditbundle',
            ).length === 1;
          return (
            <div className={classes.expandFilters} style={{ marginBottom: 20 }}>
              <GridContainer>
                <GridItem xs={12} md={6}>
                  <SectionDivider label={t('credit_bundles.filters.bundle')}>
                    <div style={{ padding: 10 }}>
                      <GridContainer>
                        <GridItem xs={12} md={4}>
                          <CustomInput
                            data-cy="adsFilterPaidAdId"
                            id="paidadId"
                            formControlProps={{
                              className: `${classes.top} ${classes.search}`,
                            }}
                            inputProps={{
                              placeholder: t('credit_bundles.filters.paidad'),
                              inputProps: {
                                'aria-label': 'Search',
                                className: classes.searchInput,
                              },
                              onChange: e => {
                                const { value } = e.target;
                                this.handleChangeFilter({
                                  paidAd: value || undefined,
                                });
                              },
                              value:
                                localFilter.paidAd !== undefined
                                  ? localFilter.paidAd
                                  : '',
                              type: 'number',
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} md={12}>
                          <GridContainer>
                            <GridItem xs={12} md={6}>
                              {(hasGeneral ||
                                user.rank === userRanks.ADMIN) && (
                                <div>
                                  <div
                                    className={`${classes.userSelect} ${
                                      localFilter.agency
                                        ? classes.userSelected
                                        : ''
                                    }`}
                                  >
                                    <Button
                                      id="selectManager"
                                      simple
                                      color="info"
                                      onClick={() => {
                                        this.setState({
                                          showSelectAgency: !showSelectAgency,
                                        });
                                      }}
                                    >
                                      <div>
                                        <p className="title">
                                          {t('credit_bundles.filters.agency')}
                                        </p>
                                        <p className="user">
                                          {localFilter.agencyName
                                            ? localFilter.agencyName
                                            : t(
                                                'credit_bundles.filters.select_placeholder',
                                              )}
                                        </p>
                                      </div>
                                    </Button>

                                    {localFilter.agency ? (
                                      <Button
                                        simple
                                        onClick={() => {
                                          this.handleChangeFilter({
                                            agency: undefined,
                                            agencyName: undefined,
                                            userAgency: undefined,
                                            userAgencyName: undefined,
                                          });
                                        }}
                                      >
                                        <Clear />
                                      </Button>
                                    ) : (
                                      <span>
                                        <SupervisedUser />
                                      </span>
                                    )}
                                  </div>

                                  {showSelectAgency && (
                                    <SweetAlert
                                      title=""
                                      showConfirm={false}
                                      showCancel={false}
                                      onConfirm={() => {}}
                                      customClass={classes.adModalConfirmation}
                                      show={showSelectAgency}
                                      closeOnClickOutside
                                      onCancel={() =>
                                        this.setState({
                                          showSelectAgency: !showSelectAgency,
                                        })
                                      }
                                    >
                                      <UserSelect
                                        listAgencies
                                        selectUser={this.handleSelectedAgency}
                                      />
                                    </SweetAlert>
                                  )}
                                </div>
                              )}
                              <div style={{ marginTop: 20 }}>
                                <div
                                  className={`${classes.userSelect} ${
                                    localFilter.userAgency
                                      ? classes.userSelected
                                      : ''
                                  }`}
                                >
                                  <Button
                                    simple
                                    color="info"
                                    onClick={() => {
                                      this.setState({
                                        showSelectOwner: !showSelectOwner,
                                      });
                                    }}
                                  >
                                    <span>
                                      <p className="title">
                                        {t('credit_bundles.filters.userAgency')}
                                      </p>
                                      <p className="user">
                                        {localFilter.userAgencyName
                                          ? localFilter.userAgencyName
                                          : t(
                                              'credit_bundles.filters.select_placeholder',
                                            )}
                                      </p>
                                    </span>
                                  </Button>

                                  {localFilter.userAgency ? (
                                    <Button
                                      simple
                                      onClick={() => {
                                        this.handleChangeFilter({
                                          userAgency: undefined,
                                          userAgencyName: undefined,
                                        });
                                      }}
                                    >
                                      <Clear />
                                    </Button>
                                  ) : (
                                    <span>
                                      <User />
                                    </span>
                                  )}
                                </div>

                                <SweetAlert
                                  title=""
                                  showConfirm={false}
                                  showCancel={false}
                                  onConfirm={() => {}}
                                  customClass={classes.adModalConfirmation}
                                  show={showSelectOwner}
                                  closeOnClickOutside
                                  onCancel={() =>
                                    this.setState({
                                      showSelectOwner: !showSelectOwner,
                                    })
                                  }
                                >
                                  <UserSelect
                                    agency={
                                      localFilter.agency
                                        ? {
                                            id: localFilter.agency,
                                          }
                                        : {}
                                    }
                                    selectUser={userAgency => {
                                      this.setState({
                                        localFilter: {
                                          ...localFilter,
                                          userAgency: userAgency.id,
                                          userAgencyName: userAgency.fullname,
                                        },
                                        showSelectOwner: !showSelectOwner,
                                      });
                                    }}
                                  />
                                </SweetAlert>
                              </div>
                            </GridItem>
                          </GridContainer>
                        </GridItem>
                      </GridContainer>
                    </div>
                  </SectionDivider>
                </GridItem>
                <GridItem xs={12} md={6}>
                  <SectionDivider label={t('promoted_ad.filters.section.date')}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={6}>
                        <Datepicker
                          title={t('promoted_ad.filters.date.from')}
                          defaultValue={t(
                            'promoted_ad.filters.date.from_placeholder',
                          )}
                          onChange={date => {
                            if (localFilter.startDateLte < date) {
                              return;
                            }
                            this.handleChangeFilter({
                              startDateGte: date
                                ? moment(date)
                                    .startOf('day')
                                    .format()
                                : undefined,
                            });
                          }}
                          value={
                            localFilter.startDateGte !== undefined
                              ? moment(localFilter.startDateGte)
                              : ''
                          }
                          validGte={localFilter.startDateLte}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <Datepicker
                          title={t('promoted_ad.filters.date.to')}
                          defaultValue={t(
                            'promoted_ad.filters.date.to_placeholder',
                          )}
                          onChange={date => {
                            if (localFilter.startDateGte > date) {
                              return;
                            }
                            this.handleChangeFilter({
                              startDateLte: date
                                ? moment(date)
                                    .endOf('day')
                                    .format()
                                : undefined,
                            });
                          }}
                          value={
                            localFilter.startDateLte !== undefined
                              ? moment(localFilter.startDateLte)
                              : ''
                          }
                          validLte={localFilter.startDateGte}
                        />
                      </GridItem>
                    </GridContainer>
                  </SectionDivider>
                  <SectionDivider
                    label={t('promoted_ad.filters.section.status')}
                  >
                    <GridItem>
                      <GridContainer>
                        <GridItem xs={12} md={8}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                onClick={() =>
                                  this.handleStatusCheck(
                                    creditBundlesStatus.CREATED,
                                  )
                                }
                                checked={
                                  selectedCreditBundlesStatus.indexOf(
                                    creditBundlesStatus.CREATED,
                                  ) !== -1
                                }
                                checkedIcon={
                                  <Check className={classes.checkedIcon} />
                                }
                                icon={
                                  <Check className={classes.uncheckedIcon} />
                                }
                                className={classes.checked}
                              />
                            }
                            id="createdCheckbox"
                            label={t('credit_bundles.filters.status.created')}
                            style={{ width: '100%' }}
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                onClick={() =>
                                  this.handleStatusCheck(
                                    creditBundlesStatus.STARTED,
                                  )
                                }
                                checked={
                                  selectedCreditBundlesStatus.indexOf(
                                    creditBundlesStatus.STARTED,
                                  ) !== -1
                                }
                                checkedIcon={
                                  <Check className={classes.checkedIcon} />
                                }
                                icon={
                                  <Check className={classes.uncheckedIcon} />
                                }
                                className={classes.checked}
                              />
                            }
                            id="startedCheckbox"
                            label={t('credit_bundles.filters.status.started')}
                            style={{ width: '100%' }}
                          />
                        </GridItem>
                        <GridItem xs={12} md={4}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                onClick={() =>
                                  this.handleStatusCheck(
                                    creditBundlesStatus.COMPLETED,
                                  )
                                }
                                checked={
                                  selectedCreditBundlesStatus.indexOf(
                                    creditBundlesStatus.COMPLETED,
                                  ) !== -1
                                }
                                checkedIcon={
                                  <Check className={classes.checkedIcon} />
                                }
                                icon={
                                  <Check className={classes.uncheckedIcon} />
                                }
                                className={classes.checked}
                              />
                            }
                            id="completedCheckbox"
                            label={t('credit_bundles.filters.status.completed')}
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                onClick={() =>
                                  this.handleStatusCheck(
                                    creditBundlesStatus.EXPIRED,
                                  )
                                }
                                checked={
                                  selectedCreditBundlesStatus.indexOf(
                                    creditBundlesStatus.EXPIRED,
                                  ) !== -1
                                }
                                checkedIcon={
                                  <Check className={classes.checkedIcon} />
                                }
                                icon={
                                  <Check className={classes.uncheckedIcon} />
                                }
                                className={classes.checked}
                              />
                            }
                            id="expiredCheckbox"
                            label={t('credit_bundles.filters.status.expired')}
                            style={{ width: '100%' }}
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                onClick={() =>
                                  this.handleStatusCheck(
                                    creditBundlesStatus.CANCELLED,
                                  )
                                }
                                checked={
                                  selectedCreditBundlesStatus.indexOf(
                                    creditBundlesStatus.CANCELLED,
                                  ) !== -1
                                }
                                checkedIcon={
                                  <Check className={classes.checkedIcon} />
                                }
                                icon={
                                  <Check className={classes.uncheckedIcon} />
                                }
                                className={classes.checked}
                              />
                            }
                            id="cancelledCheckbox"
                            label={t('credit_bundles.filters.status.cancelled')}
                            style={{ width: '100%' }}
                          />
                        </GridItem>
                        <GridItem xs={12}>
                          <GridContainer justify="flex-end">
                            <GridItem>
                              <Button
                                color="primary"
                                simple
                                className={classes.buttons}
                                onClick={() =>
                                  this.setState(
                                    {
                                      selectedCreditBundlesStatus:
                                        selectedCreditBundlesStatus.length > 0
                                          ? []
                                          : [
                                              creditBundlesStatus.CREATED,
                                              creditBundlesStatus.STARTED,
                                              creditBundlesStatus.COMPLETED,
                                              creditBundlesStatus.EXPIRED,
                                              creditBundlesStatus.CANCELLED,
                                            ],
                                    },
                                    this.updateSelectedCheckboxes,
                                  )
                                }
                                id="unselectAll"
                                key="unselectAll"
                              >
                                {selectedCreditBundlesStatus.length > 0
                                  ? t('ad.filters.status.uncheck')
                                  : t('ad.filters.status.check')}
                              </Button>
                            </GridItem>
                          </GridContainer>
                        </GridItem>
                      </GridContainer>
                    </GridItem>
                  </SectionDivider>
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <Button
                    color="primary"
                    simple
                    className={classes.buttons}
                    onClick={showFilters}
                    id="hideFilters"
                    key="hideFilters"
                  >
                    <ArrowUp />
                    {t('ad.filters.shrink')}
                  </Button>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <GridContainer justify="flex-end">
                    <GridItem>
                      <Button
                        color="danger"
                        simple
                        className={classes.buttons}
                        onClick={() => {
                          this.setState({
                            selectedCreditBundlesStatus: defaultSelectedStatus,
                            localFilter: {},
                          });
                          restartFilters();
                        }}
                        id="restartFilters"
                        key="restartFilters"
                      >
                        {t('ad.filters.clean')}
                      </Button>
                      <Button
                        data-cy="filterAds"
                        color="primary"
                        className={classes.buttons}
                        onClick={() => {
                          this.handleFilter();
                          showFilters();
                        }}
                        id="filterAds"
                        key="filterAds"
                      >
                        {t('ad.filters.filter')}
                      </Button>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
            </div>
          );
        }}
      </AuthContext.Consumer>
    );
  }
}

/**
 * CreditBundleFilter PropTypes
 * @param classes - styles received from withStyles
 * @param appliedFilter - prop to know applied filters
 * @param t - prop from HOC with string translations
 * @callback filter - callback called when user clicks filter button
 * @callback showFilters - callback called when user clicks filters button
 * @callback restartFilters - callback called when user restart filters button
 */

CreditBundleFilter.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  appliedFilter: PropTypes.shape({}).isRequired,
  filter: PropTypes.func.isRequired,
  showFilters: PropTypes.func.isRequired,
  restartFilters: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(withStyles(FilterStyles)(CreditBundleFilter));
